<template lang="html">
  <div class="profile-addresses-box col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12 no-pad-both">
    <CustomAddress v-if="showCustomAddress" :addressLookup="false" @addressReady="addNewAddress" @close="showCustomAddress = false;"></CustomAddress>

    <div id="addresses-empty-data" class="col-12 white-box" v-if="favoriteData.address.length == 0">
      <div><span class="material-icons" aria-hidden="true">place</span></div>
      <h4>Du har endnu ikke tilføjet adresser til din profil.</h4>
      <p>
        Her kan du tilføje adresser, som du ofte bruger, fx din bopæl og/eller din arbejdsplads.
        Dine adresser kommer frem som forslag, når du søger på start- og slutpunkter i Odense Rundt.
      </p>
    </div>

    <div id="add-new-address-btn" class="col-12 white-box no-pad-both" @click="showCustomAddress = true;" tabindex="0">
      <span>Tilføj ny adresse</span>
      <span class="material-icons grey-text" aria-hidden="true">add</span>
    </div>

    <ul id="profile-addresses-list" class="white-box col-12 no-pad-both" v-if="favoriteData.address.length != 0">
      <template v-for="(address, index) in favoriteData.address">
        <ProfileAddressChild :addressData="address" @removeAddress="removeAddress"></ProfileAddressChild>
      </template>
    </ul>

  </div>
</template>

<script>
import ProfileAddressChild from '@/components/profile/ProfileAddressChild.vue'
import Profile from '@/assets/profile/Profile.js'
import CustomAddress from '@/components/customAddress/CustomAddress.vue'

export default {
  data() {
    return {
      favoriteData: {
        'address': [],
        'link': [],
        'place': [],
        'themes': [],
      },
      showCustomAddress: false,
    }
  },
  components: {
    ProfileAddressChild, CustomAddress
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      Profile.getUserData().then((data) => {
        Profile.getLikeData(data.likes).then((finalData) => {
          this.favoriteData = finalData;
          //console.log(this.favoriteData);
        });
      });
    },
  	addNewAddress(options) {
      console.log(options);
      //Rewrite of options because user data expects lat,lng names
      var addressOptions = {
        name: options.name,
        alias: options.alias,
        coords: {
          lat: options.coords.latitude,
          lng: options.coords.longitude,
        }
      }
      this.showCustomAddress = false;
      Profile.addUserAddress(addressOptions).then(() => {
        this.getData();
      });
  	},
    removeAddress(id) {
      Profile.deleteUserAddress(id).then(() => {
        this.getData();
      });
    },
  },
}
</script>

<style lang="css" scoped>
  #profile-addresses-list {
  	margin: 10px 0 0 0;
  	padding: 0px 10px;
  }

  #profile-addresses-list li {
  	padding: 10px 0px 10px 10px;
    border-bottom: 1px solid #eee;
  	display: table;
    width: 100%;
  }

  #add-new-address-btn {
    margin-top: 10px;
    height: 45px;
    line-height: 45px;
    vertical-align: middle;
    text-align: center;
    cursor: pointer;
  }

  #add-new-address-btn span:first-child {
  	font-size: 20px;
  	text-transform: uppercase;
  	color: rgb(000,112,141);
  }

  #add-new-address-btn .material-icons {
    position: relative;
  	bottom: -7px;
  	font-size: 35px;
  }

  #addresses-empty-data {
    margin-top: 10px;
  	padding: 10px 5px;
  	height: auto;
    text-align: center;
  }
</style>
